import React from 'react';

export const GoogleCalendarIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M21 5V4c0-1.1-.9-2-2-2h-1V1h-2v1H8V1H6v1H5c-1.1 0-2 .9-2 2v1h18z" fill="#34a853"/>
    <path d="M3 7v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7H3zm7 10H7v-2h3v2zm0-4H7V9h3v4zm5 4h-3v-2h3v2zm0-4h-3V9h3v4z" fill="#4285f4"/>
    <path d="M21 5H3V4c0-1.1.9-2 2-2h1V1h2v1h8V1h2v1h1c1.1 0 2 .9 2 2v1z" fill="#1a73e8"/>
    <g fill="#fabb05">
        <path d="M10 17H7v-2h3v2zM10 13H7V9h3v4z"/>
    </g>
    <g fill="#ea4335">
        <path d="M17 17h-3v-2h3v2zM17 13h-3V9h3v4z"/>
    </g>
  </svg>
);